import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login = ({ onLogin, setError, error }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({ userId: "", password: "" });

  const handleChange = (e) => {
    const target = e.target.id.split("login_")[1];
    setData({ ...data, [target]: e.target.value });
    setError("");
  };

  const handleSignIn = () => {
    if (
      data.userId &&
      data.userId.length > 3 &&
      data.password &&
      data.password.length > 7
    ) {
      onLogin(data);
    } else {
      setError("아이디와 비밀번호를 정확하게 입력하세요.");
    }
  };

  const handleFindOut = () => {
    navigate("/findout");
  };

  const handleSignUp = () => {
    navigate("/signup");
  };

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      handleSignIn();
    }
  };

  return (
    <div className="hero min-h-screen place-items-stretch sm:place-items-center sm:bg-base-200 scrollbar-hide bg-white">
      <div className="hero-content flex-col lg:flex-row-reverse">
        <div className="card flex-shrink-0 w-full sm:w-96 sm:shadow-2xl sm:bg-base-100">
          <div className="card-body" onKeyUp={handleKeyUp}>
            <div className="form-control">
              <input
                id="login_userId"
                type="text"
                placeholder="아이디"
                className="input input-bordered"
                onChange={handleChange}
              />
            </div>
            <div className="form-control">
              <input
                id="login_password"
                type="password"
                placeholder="비밀번호"
                className="input input-bordered"
                onChange={handleChange}
              />
            </div>
            {/* <label className="label label-text-alt">
              계정 및 비밀번호 생성 및 분실의 경우 관리자에게 문의하세요.
            </label> */}
            {error && (
              <div className="inline-flex shadow-sm p-2 rounded-md items-center bg-red-500 border border-red-500 text-red-500 bg-opacity-10">
                <div className="inline-flex gap-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="stroke-current flex-shrink-0 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-sm">{error}</span>
                </div>
              </div>
            )}
            <div className="form-control mt-6 flex gap-3">
              <button className="btn btn-primary" onClick={handleSignIn}>
                로그인
              </button>
              <button
                className="btn btn-ghost btn-xs text-primary hover:bg-white"
                onClick={handleFindOut}
              >
                아이디 찾기 및 비밀번호 재설정
              </button>
              <hr />
              <button className="btn btn-accent" onClick={handleSignUp}>
                회원가입
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
